module.exports = __webpack_public_path__ + "static/media/25.cf611119.mp3";